<template>
  <nav
    v-if="total > 1"
    class="col-md-12 col-lg-auto d-flex justify-content-center"
    aria-label="Users pagination"
  >
    <ul class="pagination">
      <li v-if="value != 1" class="page-item" @click.prevent="update(1)">
        <a href="" class="page-link text-dark">&lt;&lt;</a>
      </li>
      <li
        v-if="value != 1"
        class="page-item"
        @click.prevent="update(Math.max(1, value - 5))"
      >
        <a href="" class="page-link text-dark">
          &lt;
        </a>
      </li>
      <li
        v-for="i in total"
        :key="i"
        class="page-item"
        :class="{ active: value === i }"
      >
        <a
          v-if="Math.abs(i - value) < 3"
          class="page-link"
          href=""
          @click.prevent="update(i)"
          v-text="i"
        ></a>
      </li>
      <li
        v-if="value != total"
        class="page-item"
        @click.prevent="update(Math.min(total, value + 5))"
      >
        <a href="" class="page-link text-dark">
          &gt;
        </a>
      </li>
      <li v-if="value != total" class="page-item">
        <a href="" class="page-link text-dark" @click.prevent="update(total)">
          &gt;&gt;
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    total: { required: true, type: Number },
    value: { required: true, type: Number },
    perPage: { required: true, type: Number },
  },
  methods: {
    update(i) {
      this.$emit("input", i)
    },
  },
}
</script>
